// import tinymce, { Editor } from "tinymce";
import { Editor } from "tinymce";
import * as Buttons from "./ui/Buttons";
import { TConditionFields } from "types";

export default (editor: Editor, conditionFields?: TConditionFields): void => {
    Buttons.register(editor, conditionFields);
};
